import React from 'react'
import { Modal, App } from 'antd'
import { useIncomeExpenditureHxCancelMutation,} from '../../store/ReactWebSiteApi';

function ArapEnterDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useIncomeExpenditureHxCancelMutation()   
    return (
        <a onClick={() => {
            confirm({
                title: '确定取消下账？取消后收支将改为待下账',
                content: props.eie_hx_number,
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    submitDel({eie_hx_number:props.eie_hx_number}).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('取消下账成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('取消下账失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}>取消下账</a>
    )
}

export default ArapEnterDel